module.exports = __webpack_public_path__ + "img/p3_l.95ead266.jpg";